import type { Equipment } from "../equipment/Equipment.typed";
import type { RentalModel } from "./RentalModel";
import type {
  Rental,
  RentalAddItemRequest,
  RentalCreateRequest,
  RentalItem,
  RentalListFilters,
  RentalModelPricing,
  RentalModelPricingUpdate,
  RentalProduct,
  RentalProductRequest,
  RentalUpdateRequest,
} from "./Rental.typed";

export class RentalAdapter {
  constructor(private model: RentalModel) {}

  async listRentalProducts(): Promise<RentalProduct[]> {
    return this.model.listRentalProducts();
  }

  async getRentalProduct(id: number): Promise<RentalProduct> {
    return this.model.getRentalProduct(id);
  }

  async createRentalProduct(payload: RentalProductRequest): Promise<RentalProduct> {
    return this.model.createRentalProduct(payload);
  }

  async updateRentalProduct(id: number, payload: RentalProductRequest): Promise<RentalProduct> {
    return this.model.updateRentalProduct(id, payload);
  }

  async deleteRentalProduct(id: number): Promise<void> {
    return this.model.deleteRentalProduct(id);
  }

  async listRentals(filters?: RentalListFilters): Promise<Rental[]> {
    return this.model.listRentals(filters);
  }

  async getRental(id: number): Promise<Rental> {
    return this.model.getRental(id);
  }

  async createRental(payload: RentalCreateRequest): Promise<Rental> {
    return this.model.createRental(payload);
  }

  async updateRental(id: number, payload: RentalUpdateRequest): Promise<Rental> {
    return this.model.updateRental(id, payload);
  }

  async deleteRental(id: number): Promise<void> {
    return this.model.deleteRental(id);
  }

  async addRentalItem(rentalID: number, payload: RentalAddItemRequest): Promise<RentalItem> {
    return this.model.addRentalItem(rentalID, payload);
  }

  async returnRentalItem(
    rentalID: number,
    itemID: number,
    state: "returned" | "not_returned" = "returned",
  ): Promise<void> {
    return this.model.returnRentalItem(rentalID, itemID, state);
  }

  async removeRentalItem(rentalID: number, itemID: number): Promise<void> {
    return this.model.removeRentalItem(rentalID, itemID);
  }

  async listAvailableEquipments(modelID?: number, query?: string): Promise<Equipment[]> {
    return this.model.listAvailableEquipments(modelID, query);
  }

  async listRentalModelPricing(): Promise<RentalModelPricing[]> {
    return this.model.listRentalModelPricing();
  }

  async updateRentalModelPricing(
    modelID: number,
    payload: RentalModelPricingUpdate,
  ): Promise<void> {
    return this.model.updateRentalModelPricing(modelID, payload);
  }
}
